import { Injectable } from "@angular/core";
import { Login } from "src/app/shared/models";
import { Observable, observable } from "rxjs";
import { HttpRestService, BaseService, apiPath } from "@services";
import { map } from 'rxjs/operators';
import { ObserversModule } from "@angular/cdk/observers";
import { HttpClient } from "@angular/common/http";
import { Router, RouterStateSnapshot } from "@angular/router";
import { environment } from "@environment/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TokenHelper } from "src/app/helpers/token-helper";
@Injectable({
  providedIn: "root",
})
export class AuthService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    protected _route: Router,
    public Alerts: MatSnackBar
  ) {
    super(httpClient);
  }

  public userLogin(data: Login) {
    let onSuccess = (value: any) => {
      let obj = null
      value.subscribe(data => {
        obj = data
      })
      if (obj?.data?.success) {
        console.log(obj.data.data)
        this.Alerts.open('Login Successfull', 'ok');
        return obj.data.data;
      }
      else {
        this.Alerts.open(obj.data.message, 'ok');
        return false
      }

    }
    return this.service(this.post(apiPath.authLogin, data)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }


  public Logout() {
    TokenHelper.removeAccessToken();
    this._route.navigate(["/login"], {
      // queryParams: { returnUrl: this._route.routerState.snapshot.url },
    });
  }

}
